import { render, staticRenderFns } from "./lookError.vue?vue&type=template&id=45276320&scoped=true"
import script from "./lookError.vue?vue&type=script&lang=js"
export * from "./lookError.vue?vue&type=script&lang=js"
import style0 from "./lookError.vue?vue&type=style&index=0&id=45276320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45276320",
  null
  
)

export default component.exports